import { useState } from "react";
import { useDispatch } from "react-redux";

import axiosApi from "../axios";

import { addNotification } from "../../store/actions/notifierActions";
import { DEFAULT_AGENT_OS, getAgentOs } from "../constants/agentOs";

const useDownloadCFAgent = () => {
  const dispatch = useDispatch();

  const [downloadOptions, setDownloadOptions] = useState({
    loaded: 0,
    total: 0,
    progress: 0,
    downloadStarted: false,
  });
  const [fileName, setFileName] = useState("");

  const standaloneAgentDownloadHandler = async (osId = DEFAULT_AGENT_OS.id) => {
    const agentOs = getAgentOs(osId);
    const requestedFileName = `cfagent.${agentOs.collectorExtension}`;

    const options = {
      onDownloadProgress: (progressEvent) => {
        const { loaded, total, progress } = progressEvent;
        setDownloadOptions({
          loaded,
          total,
          progress: progress * 100,
          downloadStarted: loaded && progress > 0 ? true : false,
        });
      },
    };
    try {
      const response = await axiosApi.get(`api/agent/download/standalone-agent?os=${agentOs.id}`, {
        responseType: "blob",
        ...options,
      });
      const fileName =
        response.headers["content-disposition"]?.split("filename=")[1] || requestedFileName;
      setFileName(fileName);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      setDownloadOptions((options) => ({ ...options, downloadStarted: false }));
      dispatch(
        addNotification({
          message:
            err?.response?.status === 404
              ? `${agentOs.value} standalone collector (${requestedFileName}) could not be found on the server.`
              : `Downloading the ${agentOs.value} standalone collector failed.`,
          options: { variant: "error" },
        }),
      );
    } finally {
      setTimeout(() => {
        setDownloadOptions((options) => ({ ...options, downloadStarted: false }));
      }, 1500);
    }
  };

  return { downloadOptions, fileName, standaloneAgentDownloadHandler };
};

export default useDownloadCFAgent;
